class A90EProductCardSelector {
  constructor(card) {
    this.card = card;
    this.card.addEventListener('change', this.handleChange);
    this.setupCarousel();

    const selectedVariant = this.card.querySelector('[data-a90e-variant-selector]:checked');
    if (selectedVariant) this.updateSelection(selectedVariant);
  }

  handleChange = (event) => {
    const selector = event.target.closest('[data-a90e-variant-selector]');
    if (!selector) return;

    this.updateSelection(selector);
  };

  updateSelection = (selector) => {
    const variantId = selector.value;
    if (!variantId) return;

    const variantInputs = this.card.querySelectorAll('[data-a90e-variant-input]');
    const variantButtons = this.card.querySelectorAll('[data-a90e-variant-button]');
    const productImage = this.card.querySelector('.product-card__media-link > img');
    const productLinks = this.card.querySelectorAll('a[href*="/products/"]');

    for (const input of variantInputs) {
      input.value = variantId;
    }

    for (const button of variantButtons) {
      button.dataset.variantId = variantId;
    }

    if (productImage && selector.dataset.a90eImageSrc) {
      productImage.src = selector.dataset.a90eImageSrc;
      productImage.srcset = selector.dataset.a90eImageSrcset || '';
      productImage.alt = selector.dataset.a90eImageAlt || productImage.alt;
    }

    if (selector.dataset.a90eVariantUrl) {
      for (const link of productLinks) {
        link.href = selector.dataset.a90eVariantUrl;
      }
    }
  };

  setupCarousel = () => {
    const slider = this.card.closest('slider-element');
    if (!slider || slider.dataset.a90eCarouselReady) return;

    slider.dataset.a90eCarouselReady = 'true';
    const panel = slider.closest('[role="tabpanel"]');

    const refreshCarousel = () => {
      window.requestAnimationFrame(() => {
        if (!slider.clientWidth) return;

        slider.reset?.();
        slider.updateButtons?.();
        slider.updateTabindex?.();
      });
    };

    const resizeObserver = new ResizeObserver(refreshCarousel);
    resizeObserver.observe(slider);

    if (panel) {
      const panelObserver = new MutationObserver(refreshCarousel);
      panelObserver.observe(panel, { attributes: true, attributeFilter: ['hidden'] });
    }

    refreshCarousel();
  };
}

const initializeA90EProductCards = (root = document) => {
  const cards = root.querySelectorAll('[data-a90e-product-card]:not([data-a90e-selector-ready])');

  for (const card of cards) {
    card.dataset.a90eSelectorReady = 'true';
    new A90EProductCardSelector(card);
  }
};

initializeA90EProductCards();

document.addEventListener('shopify:section:load', (event) => {
  initializeA90EProductCards(event.target);
});

document.addEventListener('sectionsRenderingAPI:cached', () => {
  initializeA90EProductCards();
});
